<template>
	<div>
		<template v-if="asientos.length != 0">
			<label>{{ $t('nuevo_abono.tus_asientos') }}</label>
			<ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
				<template v-for="(asiento, index) in asientos" class="mb-4">
					<div class="lightgray-content p-2 mb-2" :key="index">
						<div class="text-bold mb-2 d-md-flex">
							<div class="oswald">
								{{ $t('general.abono') }} {{ ++index }}. 
								<span v-if="asiento.asiento.zona_nombre">{{ asiento.asiento.zona_nombre }}</span>
							</div>
							<div class="ml-2">
								<small v-if="asiento.asiento.fila">{{ $t('general.fila') }}: {{ asiento.asiento.fila }} /</small> 
								<small v-if="asiento.asiento.asiento">{{ $t('general.butaca') }}: {{ asiento.asiento.asiento }}</small>
							</div>
						</div>
					</div>
				</template>
				<button class="button effect-button large-button mb-4 mb-lg-5"  @click.prevent="continuar" type="submit" v-if="configuracion_valida && can_click"><span>{{ $t('nuevo_abono.continuar_compra') }}</span></button>
				<div v-if="!configuracion_valida" class="alert alert-warning">
					{{ $t('nuevo_abono.no_huecos') }}
				</div>
			</ValidationObserver>
		</template>
	</div>
</template>

<script>
    export default {
		props: ['asientos', 'precios', 'configuracion_valida', 'can_click'],
        data() {
            return {
            }
        },
        methods: {
            continuar() {
            	/**
            	for(var i in this.asientos) {
            		for (var j in this.precios) {
            			if(this.precios[j].id == this.asientos[i].asiento.event_ticket_id) {
            				this.asientos[i].precio = this.precios[j];
            			}
            		}
            	}**/
				this.$emit('continuar', this.asientos);
            }
        },
    }
</script>

<style>
    
</style>
